/**
 * Call a promise for each param found.
 * @param {Array[]} params - An array of arrays that consist of two values the parameter's name and the parameter's value.
 * @param {Function | Promise} fn - The callback function that is called for each parameter passed.
 *
 * @example
 * forEachParam([
 *     [ `someParam`, `some-value` ],
 *     [ `anotherParam`, `another-value` ],
 * ], (paramName, paramValue) => {
 *     console.log(`param "${paramName}" set to: "${paramValue}".`);
 * })
 */

async function forEachParam (params, fn) {
	for (let i = 0; i < params.length; i++) {
		const [key, value] = params[i];

		await fn(key, value);
	}
}

export { forEachParam };
